<template>
  <div class="job-board-point-history-container">
    <Navigation :pathList="navigationArray"/>
    <div class="body-content">
      <div class="header-container">
        <span class="name-label">{{ companyName }}</span>
        <el-select
          class="channel-select"
          v-model="activityType"
          @change="handelChangeType"
        >
          <el-option
            v-for="item in activityTypeList"
            :key="item.key"
            :label="$t(item.label)"
            :value="item.key">
          </el-option>
        </el-select>
      </div>
      <History v-loading="showLoading" :listData="historyList" :tableColumns="tableColumns"/>
      <div class="pagination-container">
        <el-pagination
          class="pagination"
          background
          :current-page="pageSetting.currentPage"
          layout="prev, pager, next"
          :total="pageSetting.total"
          :page-size="pageSetting.pageSize"
          @current-change="handelPageChange"
          >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { isEn } from '@/i18n'
import { mapActions } from 'vuex'
import { formatBigNumber } from '@/components/filters'
import Navigation from '../../components/navigation.vue'
import History from '../../components/pointChangeHistory.vue'

export default {
  components: {
    Navigation,
    History
  },
  data () {
    const i18nPrefix = 'admin.company.jobBoardPointDashboard'
    return {
      formatBigNumber,
      i18nPrefix: i18nPrefix,
      listData: [],
      navigationArray: [
        {
          i18nName: `${i18nPrefix}.title.index`,
          path: '/v-admin/client-admin/job-board-point-dashboard'
        },
        {
          i18nName: `${i18nPrefix}.title.history`,
          path: '',
          current: true
        }
      ],
      activityType: 'all',
      activityTypeList: [
        {
          key: 'all',
          label: `${i18nPrefix}.label.all`
        },
        {
          key: 'add',
          label: `${i18nPrefix}.label.purchased`
        },
        {
          key: 'subtract',
          label: `${i18nPrefix}.label.allocated`
        }
      ],
      companyInfo: {
        name: '',
        cn_name: ''
      },
      showLoading: false,
      pageSetting: {
        currentPage: 1,
        total: 0,
        pageSize: 10
      }
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.purchaseDate`),
          dataKey: 'create_date'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.job`),
          dataKey: isEn() ? 'job_title' : 'job_cn_title'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.activity`),
          dataKey: 'activity'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.points`),
          dataKey: 'points'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.note`),
          dataKey: 'note'
        }
      ]
      return columns
    },
    companyId () {
      return this.$route.params.companyId
    },
    companyName () {
      let companyName = this.companyInfo[isEn() ? 'name' : 'cn_name']
      if (!companyName) {
        companyName = this.companyInfo.name || this.companyInfo.cn_name
      }
      return `${companyName} ${this.$t(`${this.i18nPrefix}.title.history`)}`
    },
    historyList () {
      const result = []
      _.forEach(this.listData, (item) => {
        const tempData = { ...item }
        tempData.points = this.formatBigNumber(tempData.points)
        if (tempData.activity === 'subtract') {
          tempData.activity = this.$t(`${this.i18nPrefix}.label.allocated`)
          tempData.points = `-${tempData.points}`
        } else {
          tempData.activity = this.$t(`${this.i18nPrefix}.label.purchased`)
        }
        tempData.create_date = moment(tempData.create_date).format('YYYY/MM/DD')
        result.push(tempData)
      })
      return result
    }
  },
  created () {
    const type = this.$route.query.type
    if (type && _.find(this.activityTypeList, 'key', type)) {
      this.activityType = type
    }
    this.initListData()
  },
  mounted () {
  },
  methods: {
    ...mapActions('company', ['getCompanyJobBoardPointDashboardHistory']),
    async initListData () {
      this.showLoading = true
      try {
        const resp = await this.getCompanyJobBoardPointDashboardHistory({
          page: this.pageSetting.currentPage,
          company_id: this.companyId,
          page_size: this.pageSetting.pageSize,
          activity: this.activityType
        })
        if (resp) {
          this.listData = resp.list
          this.pageSetting.total = resp.total_count
          this.companyInfo = resp.company
        }
      } finally {
        this.showLoading = false
      }
    },
    handelChangeType () {
      this.$router.push({ path: this.$router.path, query: { ...this.$route.query, type: this.activityType } })
      this.handelPageChange(1)
    },
    handelPageChange (page) {
      this.pageSetting.currentPage = page
      this.initListData()
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.job-board-point-history-container {
  .body-content {
    background: #FFFFFF;
    padding: 30px;

    .header-container {
      margin-bottom: 20px;
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .channel-select {
        width: 400px;
      }

      .name-label {
        font-size: 16px;
      }
    }
    .pagination-container {
      padding-top: 20px;
      text-align: center;
    }
  }
}
</style>
